import { Currency } from '@uniswap/sdk-core'
import CurrencyLogo from 'components/CurrencyLogo'
import { useToken } from 'hooks/Tokens'
import React from 'react'

const TokenLogo: React.FC<{ token: string }> = ({ token }) => {
  const currency = useToken(token)

  return <CurrencyLogo size={'20px'} currency={currency as Currency} />
}
export default TokenLogo
